import React, { useEffect } from 'react';
import './footer.css';

function Footer() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://counter.websiteout.com/js/2/7/0/0";
    script.async = true;
    document.getElementById('visitor-counter').appendChild(script);
  }, []);

  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Cyber Security Research Lab (CSRL), Dept. of CSE, NITK Surathkal. All rights reserved.</p>
      <p>Developed By Gaurav Pal, Under the Guidance of Dr. Mahendra Pratap Singh.</p>
      <div id="visitor-counter" className="visitor-counter">
        <script type="text/javascript" src="https://counter.websiteout.com/js/2/7/0/0"></script>
      </div>
    </footer>
  );
}

export default Footer;
